<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:class="modalSize"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="`transaction/schedule-recommendation`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_course_name" class="col-sm-3 mb-0">
						Class Name
					</label>
					<app-input
						id="inputs_course_name"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_course_id"
						@input="setCourseIdValue"
						:fetch-url="`transaction/course?product`"
						placeholder="Choose Class"
						list-value-field="course_name"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_course_schedule_id"
						class="col-sm-3 mb-0"
					>
						Class Schedule
					</label>
					<app-input
						id="inputs_course_schedule_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_course_schedule_id"
						@input="setCourseScheduleIdValue"
						:fetch-url="`transaction/course-schedule?course_id=${this.input_course_id.id}`"
						placeholder="Choose Schedule"
						list-value-field="name"
						:disabled="
							this.input_course_id.course_name === '' ||
							!this.input_course_id.course_name
						"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_product_id" class="col-sm-3 mb-0">
						Product Name
					</label>
					<app-input
						id="inputs_product_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_product"
						@input="setProductValue"
						fetch-url="master/product?is_active=true&per_page=50"
						placeholder="Choose Product"
						list-value-field="name"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_mon" class="col-sm-3 mb-0"> Mon </label>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_1"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_1"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_tue" class="col-sm-3 mb-0"> Tue </label>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_2"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_2"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_wed" class="col-sm-3 mb-0"> Wed </label>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_3"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_3"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_thu" class="col-sm-3 mb-0"> Thu </label>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_4"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_4"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_fri" class="col-sm-3 mb-0"> Fri </label>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_5"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_5"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sat" class="col-sm-3 mb-0"> Sat </label>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_6"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_6"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sun" class="col-sm-3 mb-0"> Sat </label>
					<app-input
						id="inputs_sun"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_7"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_sun"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_7"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_date_start" class="col-sm-3 mb-0">
						Start Date
					</label>
					<app-input
						id="inputs_date_start"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start"
						placeholder="Start Date"
						:disabled="isCourseDateStartExist"
					/>
				</div>
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_date_end" class="col-sm-3 mb-0">
						End Date
					</label>
					<app-input
						id="inputs_date_end"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_end"
						placeholder="End Date"
					/>
				</div> -->
				<div class="form-group row align-items-center">
					<label for="inputs_date_clc_start" class="col-sm-3 mb-0">
						CLC Date Start
					</label>
					<app-input
						id="inputs_date_clc_start"
						class="col-sm-9"
						type="text"
						v-model="inputs.date_clc_start"
						placeholder="CLC Date Start"
						:disabled="isCourseDateClcStartExist"
					/>
				</div>
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_date_clc_end" class="col-sm-3 mb-0">
						CLC Date End
					</label>
					<app-input
						id="inputs_date_clc_end"
						class="col-sm-9"
						type="text"
						v-model="inputs.date_clc_end"
						placeholder="CLC Date End"
					/>
				</div> -->
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "AssignScheduleSecondForm",
	inject: ["eventHub"],
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		assignScheduleId: {
			type: Number,
		},
		value: {
			type: Object,
			default: () => {
				return {
					name: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			modalId: this.formId,
			modalTitle: this.$t("add"),
			modalSize: "fullscreen",
			isCourseDateStartExist: true,
			isCourseDateClcStartExist: true,
			courseScheduleLists: [],
			inputs: {
				assign_schedule_id: this.assignScheduleId,
				time_start_1: "",
				time_end_1: "",
				time_start_2: "",
				time_end_2: "",
				time_start_3: "",
				time_end_3: "",
				time_start_4: "",
				time_end_4: "",
				time_start_5: "",
				time_end_5: "",
				time_start_6: "",
				time_end_6: "",
				time_start_7: "",
				time_end_7: "",
				date_start: "",
				date_end: "",
				date_clc_start: "",
				date_clc_end: "",
			},
			input_product: this.value
				? this.value
					? {
							id: this.value.product_id.id || 0,
							name: this.value.product_id.name || "",
					  }
					: {
							id: this.value.product_id?.id || 0,
							name: this.value.product_id?.name || "",
					  }
				: {
						id: this.value.product_id.id || 0,
						name: this.value.product_id.name || "",
				  },
			input_course_id: this.value
				? this.value
					? {
							id: this.value.id || 0,
							course_name: this.value.course_name || "",
							product_id: this.value.product_id || "",
							product: this.value.product,
					  }
					: {
							id: this.value?.id || 0,
							course_name: this.value?.course_name || "",
							product_id: this.value?.product_id || "",
							product: this.value?.product,
					  }
				: {
						id: this.value.id || 0,
						course_name: this.value.course_name || "",
						product_id: this.value.product_id || "",
						product: this.value.product,
				  },
			input_course_schedule_id: this.value
				? this.value
					? {
							id: this.value.id || 0,
							course_schedule_name:
								this.value.course_schedule_name || "",
							day_id: this.value.day_id?.id || "",
							course_group_id:
								this.value.course_group_id?.id || "",
					  }
					: {
							id: this.value?.id || 0,
							course_schedule_name:
								this.value?.course_schedule_name || "",
							day_id: this.value?.day_id?.id || "",
							course_group_id:
								this.value?.course_group_id?.id || "",
					  }
				: {
						id: this.value.id || 0,
						course_schedule_name:
							this.value.course_schedule_name || "",
						day_id: this.value.day_id?.id || "",
						course_group_id: this.value.course_group_id?.id || "",
				  },
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		async fetchCourseSchedule() {
			try {
				let time_start = this.input_course_schedule_id.time_start.slice(
					0,
					-3
				);
				let time_end = this.input_course_schedule_id.time_end.slice(
					0,
					-3
				);

				if (
					this.input_course_schedule_id?.day_id?.day_name === "Monday"
				) {
					this.inputs.time_start_1 = time_start;
					this.inputs.time_end_1 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Tuesday"
				) {
					this.inputs.time_start_2 = time_start;
					this.inputs.time_end_2 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Wednesday"
				) {
					this.inputs.time_start_3 = time_start;
					this.inputs.time_end_3 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Thursday"
				) {
					this.inputs.time_start_4 = time_start;
					this.inputs.time_end_4 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name === "Friday"
				) {
					this.inputs.time_start_5 = time_start;
					this.inputs.time_end_5 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Saturday"
				) {
					this.inputs.time_start_6 = time_start;
					this.inputs.time_end_6 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name === "Sunday"
				) {
					this.inputs.time_start_7 = time_start;
					this.inputs.time_end_7 = time_end;
				}
			} catch (error) {
				console.error("Error fetching course schedule data:", error);
			}
		},
		submit() {
			this.inputs.date_start = this.formattedDate(this.inputs.date_start);
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
			this.eventHub.$emit(
				"studentAssignScheduleSecondFormSuccessCreateData"
			);
		},
		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.preloader = false;
		},

		resetCourseId() {
			this.input_course_id = {
				id: 0,
				course_name: "",
				product_id: "",
			};
		},
		resetCourseSchedule() {
			this.inputs.time_start_1 = "";
			this.inputs.time_end_1 = "";
			this.inputs.time_start_2 = "";
			this.inputs.time_end_2 = "";
			this.inputs.time_start_3 = "";
			this.inputs.time_end_3 = "";
			this.inputs.time_start_4 = "";
			this.inputs.time_end_4 = "";
			this.inputs.time_start_5 = "";
			this.inputs.time_end_5 = "";
			this.inputs.time_start_6 = "";
			this.inputs.time_end_6 = "";
			this.inputs.time_start_7 = "";
			this.inputs.time_end_7 = "";
		},
		setProductValue(data) {
			this.inputs.product_id = this.inputs.product_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.product_id = data.id;
			}
			this.resetCourseId();
			this.resetCourseSchedule();
		},
		setCourseIdValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.inputs.course_id = data.id;
				this.inputs.product_id =
					data.product_id || this.inputs.product_id;

				this.isCourseDateStartExist = Boolean(data.course_date_start);
				this.inputs.date_start = this.isCourseDateStartExist
					? data.course_date_start
					: null;

				this.isCourseDateClcStartExist = Boolean(
					data.course_date_clc_start
				);
				this.inputs.date_clc_start = this.isCourseDateClcStartExist
					? data.course_date_clc_start
					: null;

				this.input_product = {
					id: data.product.id || 0,
					name: data.product.name || "",
				};
			}
		},
		setCourseScheduleIdValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.inputs.course_schedule_id = data.id;
				console.log(data);
				this.inputs.course_group_id =
					data.course_group_id?.id ||
					this.$toast.e("Course Group ID is not found");
			}
			this.resetCourseSchedule();
			this.fetchCourseSchedule();
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
};
</script>
